import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import useWindowDimensions from "../../Hooks/useWindowDimensions";
import { Button, CircularProgress } from "@mui/material";
import CalendarIcon from "../../Assets/Images/CalendarCheck.svg";
import Person from "../../Assets/Images/person.png";
import People1 from "../../Assets/Images/people1.png";
import People2 from "../../Assets/Images/people2.png";
import People3 from "../../Assets/Images/people3.png";
import CheckCircleIcon from "../../Assets/Images/CheckCircle.svg";
import Watermark from "../../Assets/Images/watermark.png";
import WatermarkSingle from "../../Assets/Images/watermark-single.png";
import "./Resultsv2.scss";
import AssessmentCompleteModal from "../../Modals/AssessmentCompletedModal";


const Resultsv2 = () => {

  const { windowWidth } = useWindowDimensions();
  const { id } = useParams();
  const [score, setScore] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showAssessmentModal, setShowAssessmentModal] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const isCompleted = searchParams.get("completed") === "true";
  
    if (isCompleted) {
      setShowAssessmentModal(true);
    }
  }, [searchParams]);
  
 
  useEffect(() => {
    document.body.style.backgroundColor = "#FFFFFF";
    fetchResults();
  }, [id]);

  const getBarTextLeft = (score) => {
    if (window.innerWidth < 650 && score > 80) {
      return { left: "-170px" };
    }
    return { left: "-100px" };
  };
 const removeParam = () => {

  searchParams.delete("completed");
  setSearchParams(searchParams, { replace: true });

 }
  const getLeftMargin = () => {

    // if (windowWidth <= 830) {
    //   if (score > 96 && score < 100) {
    //     return { left: 96.5 + "%" };
    //   } else if (score >= 100) {
    //     return { left: 97.5 + "%" };
    //   } else if (score > 0 && score < 3) {
    //     return { left: 2.5 + "%" };
    //   } else if (score <= 0) {
    //     return { left: 1.5 + "%" };
    //   } else {
    //     return { left: Math.round(score) + "%" };
    //   }
    // } else {
    //   return { left: Math.round(score) + "%" };
    // }

    const displayScore = Math.max(0, Math.round(score)); 
    const leftValue = displayScore;
  
    if (windowWidth <= 830) {
      if (leftValue >= 100) return { left: "97.5%" };
      if (leftValue > 96) return { left: "96.5%" };
      if (leftValue <= 0) return { left: "1.5%" };
      if (leftValue < 3) return { left: "2.5%" };
      return { left: `${leftValue}%` };
    } else {

      if (leftValue >= 100) return { left: "98%" };
      if (leftValue <= 0) return { left: "1%" };
      if (leftValue < 3) return { left: "2.5%" };
      return { left: `${leftValue}%` };
    }
  };
  

  const fetchResults = async () => {
    setIsLoading(true);
    const resultsURL = `${process.env.REACT_APP_API_URI}/v3/user/assessment/${id}/results`;
    try {
      const response = await fetch(resultsURL, {
        method: "GET", mode: "cors",
        headers: { "Content-Type": "application/json" },
      });
      const data = await response.json();
      if (data.status === "success") {
        const variables = data?.variables;
        const percentVar = variables?.find(variable => variable?.variable === "percent");
        if (percentVar && typeof percentVar.score === "number") {
          setScore(Math.round(percentVar.score));
        } else if (typeof data?.score === "number") {
          // no custom scoring variables, use default score
          console.warn("Using default score as no custom scoring variables found...");
          setScore(Math.round(data.score));
        } else {
          // fallback to 0 if score is unavailable
          console.error("No valid score found in results data...");
          setScore(0);
        }
      } else {
        console.error("Failed to fetch results...", data);
      }
    } catch (err) {
      console.error("Failed to fetch results...", err);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", minHeight: "100dvh", backgroundColor: "#FFFFFF" }}>
        <CircularProgress style={{ color: "#CC972F" }} size={60} />
      </div>
    );
  }

  const getResultContent = (score) => {
    if (score <= 50) {
      return {
        title: "Unlock the potential!",
        subtext: <>Your high-capacity givers show low&nbsp;engagement.</>,
        secondSubtext: <>This is the perfect opportunity to initiate deep&nbsp;partnerships.</>
      };
    } else if (score > 50 && score <= 80) {
      return {
        title: "You’re getting there!",
        subtext: <>There’s growing engagement among your high-capacity&nbsp;givers.</>,
        secondSubtext: <>Now is the time to strengthen that&nbsp;partnership.</>
      };
    } else if (score > 80) {
      return {
        title: "Congratulations!",
        subtext: <>Your high-capacity givers feel they are partnering with&nbsp;you.</>,
        secondSubtext: <>Now is the time to align them with your long-term&nbsp;vision.</>,
      };
    }
    return {};
  };

  const content = getResultContent(score);
  const displayScore = Math.max(0, Math.round(score));


  return (
    <>
    <div className="resultsv2-container">
      <div className="result-card">
        <h2>{content.title}</h2>
        <hr className="how-divider" />
        {content && (
          <>
            <p className="subtext">{content.subtext}</p>
            <p className="second-subtext">{content.secondSubtext}</p>
          </>
        )}

        {/* <div className="progress-bar-container">
          <div className="labels">
            <span>Disconnected</span>
            <span>Involved</span>
            <span>Fulfilled</span>
          </div>
          <div className="progress-track">
            <div className="progress-fill" style={{ width: `${score}%` }}></div>
            <div className="progress-score" style={{ left: `${score}%` }}>{score}%</div>
          </div>
        </div> */}

        <div className="progress-bar">
          <div className="si_ass_result">
            <div className="si_ass_progress">
                <div className="transparent" style={{ width: `${100 - displayScore}%` }}></div> 
              <div
                className={`progress-line ${displayScore == 100 ? "hide-fade" : "" }`}
                // -2px to offset the marker width at 100% score
                style={{ left: displayScore == 100 ? `calc(${displayScore}% - 2px)` : `${displayScore}%` }}
              >
                {/* <div className="progress-text" style={ windowWidth < 651 && score < 30 ? { left: '-50px', width: '10ch', top: '-85px' } : getBarTextLeft(score)}>{showProgressBarText(score)}</div> */}
              </div>
              <span className="msi_score" style={getLeftMargin()}>
                {displayScore}%
              </span>
              {/* <div className="score-arrow" style={{ left: Math.round(score) + '%' }}></div> */}
            </div>
            <div className="pervalue">
              <h4 className="nimp1" style={{ minWidth: "0%" }}></h4>
              <h4 className="nimp" style={{ minWidth: "50%" }}></h4>
              <h4 className="mexpe" style={{ minWidth: "30%" }}></h4>
              <h4 className="eexpe" style={{ minWidth: "20%" }}></h4>
              {/* <h4 className="eexpe1" style={{ minWidth: '20%' }}></h4> */}
              {/* <h4 className="eexpe2" style={{ minWidth: '18%' }}></h4> */}
              {/* <h4 className="vexpe" style={{ minWidth: '5%' }}></h4> */}
            </div>

            <div className="si_pro_header">
              <h4 className="nimp" style={{ minWidth: "0%" }}></h4>
              <h4 className="mexpe" style={{ minWidth: "50%" }}></h4>
              <h4 className="eexpe" style={{ minWidth: "30%" }}></h4>
              {/* <h4 className="eexpe1" style={{ minWidth: '30%' }}></h4> */}
              {/* <h4 className="eexpe" style={{ minWidth: '30%' }}></h4> */}
            </div>

            {/* <div className="pervalue-text"> */}
            {/* <h4 className="nimp" style={{ minWidth: '45%',  }}></h4> */}
            {/* <h4 className="mexpe" style={{ minWidth: '25%',  }}></h4> */}
            {/* <h4 className="eexpe" style={{ minWidth: '30%', f }}></h4> */}
            {/* <h4 className="vexpe" style={{ minWidth: '5%' }}></h4> */}
            {/* </div> */}

            <div className="pervalue-text">
              <p
                className="not-aligned"
                style={{
                  width: "50%",
                  fontWeight: score >= 0 && score <= 50 ? 700 : 400,
                  // color: score <= 50 ? "#CC2C24" : "#242223",
                }}
              >
                Disconnected
              </p>
              {/* <p className="poor-aligned" style={{ marginLeft: '25%', fontWeight: score > 20 && score <= 40 ? 800 : 600 }}>Poorly<br />Aligned</p> */}
              <p
                className="some-aligned"
                style={{
                  width: "30%",
                  fontWeight: score > 50 && score <= 80 ? 700 : 400,
                  // color: score > 50 && score <= 80 ? "#FBBC27" : "#242223",
                }}
              >
                Involved
              </p>
              {/* <p className="well-aligned" style={{ marginLeft: '65%', fontWeight: score > 60 && score <= 80 ? 800 : 600 }}>Well<br />Aligned</p> */}
              <p
                className="high-aligned"
                style={{
                  width: "20%",
                  fontWeight: score > 80 ? 700 : 400,
                  // color: score > 80 ? "#242223" : "#242223",
                }}
              >
                Fulfilled
              </p>
            </div>
          </div>
        </div>
        <div className="call-card">
          <h4>
            Book a<span style={{ fontWeight: 600 }}> free </span>call with Pastor
            Reece&nbsp;to:{" "}
          </h4>
          <ul>
            <li>Unpack your results further</li>
            <li>Understand your givers better</li>
            <li>Unleash their capacity in the future</li>
          </ul>
          <div>
            <Button className="call-button" onClick={() => window.open('https://calendly.com/reece-whitehead-westfallgold/30min', '_blank')}>
              <img src={CalendarIcon} alt="Calendar Icon" /> Book a Free 30-Minute Call
            </Button>
          </div>
          <div className="img-container">
            <img src={WatermarkSingle} alt="Westfall Gold Logo" className="watermark-single" />
            <img src={Person} alt="Pastor Reece" className="pastor-img" />
          </div>
        </div>
      </div>

      <div className="recommendation-section">
        <p className="recommendation-header">
          You're on your way to successfully engaging high-capacity givers. Here
          are some ways you can improve what you're already&nbsp;doing:
        </p>

        <div className="recommendation-card">
          <img src={People1} alt="Connect Plan" />
          <div className="recommendation-text">
            <h4 className="recommendation-heading">
              <span className="step-number">1.</span>
              {/* <span className="dot">•</span> */}
              <span className="highlight">
                Make a plan to connect with high-capacity&nbsp;givers.
              </span>
            </h4>
            <p>
              The goal is to have a minimum of five touch points with every
              high-capacity giver each year. These touch points can be a variety
              of 1:1 or small relational&nbsp;gatherings.
            </p>
          </div>
        </div>

        <div className="recommendation-card">
          <img src={People2} alt="Engage Givers" />
          <div className="recommendation-text">
            <h4 className="recommendation-heading">
              <span className="step-number">2.</span>
              {/* <span className="dot">•</span> */}
              <span className="highlight">
                Engage your high-capacity givers in volunteer&nbsp;opportunities.
              </span>
            </h4>
            <p>
              Don’t shy away from asking high-capacity givers to volunteer their
              time or expertise in capacities that align with their leadership
              potential and&nbsp;strengths.
            </p>
          </div>
        </div>
        <div className="recommendation-card">
          <img src={People3} alt="Engage Givers" />
          <div className="recommendation-text">
            <h4 className="recommendation-heading">
              <span className="step-number">3.</span>
              {/* <span className="dot">•</span> */}
              <span className="highlight">
                Identify and establish a catalyst&nbsp;team.
              </span>
            </h4>
            <p>
              To fully engage your major givers, don’t do it alone. Identify
              other key leaders on your staff who can help invest in these key
              relationships with&nbsp;you.
            </p>
          </div>
        </div>
      </div>
      <div className="next-steps-card">
        <div className="card-content">
          <img src={CheckCircleIcon} alt="Check" className="check-icon" />
          <p className="message">
            Get clear next steps to unleash high-capacity giving in your&nbsp;church.
          </p>
          <Button className="cta-button" onClick={() => window.open('https://calendly.com/reece-whitehead-westfallgold/30min', '_blank')}>
            <img src={CalendarIcon} alt="Calendar" className="calendar-icon" />
            Book a Free 30-Minute Call
          </Button>
        </div>
        <img src={Watermark} alt="watermark" className="watermark-img" />
      </div>
    </div>
    <AssessmentCompleteModal
  open={showAssessmentModal}
  onClose={() => { setShowAssessmentModal(false); removeParam();} }
/>
</>
  );
};

export default Resultsv2;
